import { tv } from 'tailwind-variants';

export const intentVerificationPanelVariants = tv({
  slots: {
    container: 'flex w-full min-w-[500px]',
    column: 'flex flex-col max-w-full',
    panel: 'flex items-center justify-between p-4 cursor-pointer gap-3',
    titleSection: 'flex items-center gap-3 w-96',
    summaryTitle: 'text-xl font-semibold text-default',
    summarySection: 'flex flex-col gap-1 flex-1',
    summaryLabel: 'text-xs font-semibold text-plain',
    summaryBadges: 'flex items-center gap-3',
    chevronIcon: 'size-6 flex items-center justify-center text-default',
    tableWrapper: '',
  },
  variants: {
    expanded: {
      true: {
        panel: 'border-b border-solid border-shade-10',
        tableWrapper: '',
      },
      false: {
        tableWrapper: 'h-0 overflow-hidden',
      },
    },
  },
  defaultVariants: {
    expanded: false,
  },
});

export const intentVerificationTableVariants = tv({
  slots: {
    root: 'grid pt-4 px-4',
    row: 'contents',
    nameColumn: 'truncate pr-3',
    columnColumn: 'truncate pr-3',
    resultsColumn: 'pr-3',
    actionsColumn: '',
    headerLabel: 'text-xs font-semibold text-plain pr-3 last:pr-0',
    cellWrapper:
      'h-11 py-3 border-b border-solid border-shade-10 flex items-center',
    cellName: 'text-sm font-semibold text-default truncate',
    cellColumn: 'text-sm font-normal text-default truncate',
    actionsWrapper: 'flex items-center gap-4.5',
  },
});

export const intentResultBadgeVariants = tv({
  base: 'min-w-8 h-4 px-1 ',
});

export const intentSeverityBadgeVariants = tv({
  slots: {
    root: 'flex items-center',
    indicator: 'rounded mr-2.5 inline-flex size-4 items-center justify-center',
    label: 'text-default',
    defaultMarker: 'text-xs font-bold text-contrast',
  },
});

/**
 * Get background class for severity level
 */
export const getSeverityBgClass = (
  severity: number | string | null,
): string => {
  switch (Number(severity)) {
    case 0:
      return 'bg-severity-0';
    case 10:
      return 'bg-severity-10';
    case 20:
      return 'bg-severity-20';
    case 30:
      return 'bg-severity-30';
    default:
      return '';
  }
};
